<template>
  <vs-row vs-justify="center">
    <vs-col type="flex" vs-justify="center" vs-align="center" vs-lg="12" vs-xs="12">
      <vs-card style="overflow: hidden">
        <div class="chat-container">
          <div class="chat-list">
            <div class="chat-list-header">
              <h3 class="card-title d-flex">AI Chats</h3>
              <vs-button type="filled" class="searchBtn" icon="cached" @click="fetchLatestMessages()" style="border-radius: 100%"></vs-button>
            </div>
            <div class="chat-list-items">
              <div
                v-for="chat in latestChats"
                :key="chat._id"
                :class="['chat-list-item', { selected: selectedChat && selectedChat._id === chat._id }]"
                @click="selectChat(chat)"
              >
                <div class="chat-list-item-title">
                  <span>{{ chat.userId ? "UserID: " + chat.userId : "DeviceID: " + chat.deviceId || "Unknown" }}</span>
                </div>
                <div class="chat-list-item-message">
                  {{ chat.message.substring(0, 40) }}
                </div>
                <div class="chat-list-item-date">
                  {{ formatDate(chat.createdAt) }}
                </div>
              </div>
              <div v-if="!latestChats.length" class="no-chats">No chats found.</div>
            </div>
          </div>
          <!-- mesage box-->
          <div class="chat-message-box">
            <div v-if="selectedChat">
              <ChatMessageBox :chat="selectedChat" />
            </div>
            <div v-else class="no-chat-selected">
              <p>Select a chat to view messages</p>
            </div>
          </div>
        </div>
      </vs-card>
    </vs-col>
  </vs-row>
</template>

<script>
import api from "@/rest.js";
import { API } from "@/common/constants";
import ChatMessageBox from "./ChatMessageBox.vue";
import moment from "moment";

export default {
  name: "Chats",
  components: { ChatMessageBox },
  data: () => ({
    latestChats: [],
    limit: 10,
    page: 1,
    selectedChat: null,
  }),
  methods: {
    async fetchLatestMessages() {
      this.$vs.loading();
      try {
        const res = await api.get(`${API.AI_GET_LATEST_MESSAGES}?limit=${this.$data.limit}&page=${this.$data.page}`);
        if (res.status == 200) {
          this.$data.latestChats = res.data.data;
          console.log(this.$data.latestChats);
        }
      } catch (error) {
        this.$vs.notify({
          title: "Error",
          text: "Error fetching latest messages",
          color: "danger",
          position: "top-right",
        });
        console.log(error);
      } finally {
        this.$vs.loading.close();
      }
    },
    selectChat(chat) {
      this.selectedChat = chat;
    },
    formatDate(dateStr) {
      const m = moment(dateStr);
      if (!m.isValid()) return "Invalid date";
      return m.format("MMM DD, YYYY HH:mm A");
    },
  },
  async created() {
    await this.fetchLatestMessages();
  },
};
</script>

<style scoped>
.chat-container {
  height: 100vh;
  min-height: 100vh;
  max-height: 100vh;
  display: flex;
  flex-direction: row;
  overflow: hidden;
}
.chat-list {
  width: 320px;
  border-right: 1px solid #e0e0e0;
  display: flex;
  flex-direction: column;
  height: 100vh;
  min-height: 100vh;
  max-height: 100vh;
  overflow: hidden;
}
.chat-list-header {
  display: flex;
  justify-content: space-between;
  align-items: end;
  padding-bottom: 0.5rem;
}
.page-limit-select {
  width: 120px;
}
.chat-list-items {
  flex: 1;
  overflow-y: auto;
  min-height: 0;
  max-height: 100vh;
}
.chat-list-item {
  padding: 12px 16px;
  border-bottom: 1px solid #ececec;
  cursor: pointer;
  transition: background 0.2s;
}
.chat-list-item.selected {
  background: #b1d2fd;
}
.chat-list-item-title {
  font-weight: bold;
  font-size: 15px;
  margin-bottom: 2px;
}
.chat-list-item-message {
  color: #555;
  font-size: 13px;
  margin-bottom: 2px;
}
.chat-list-item-date {
  color: #999;
  font-size: 12px;
}
.no-chats {
  padding: 24px;
  text-align: center;
  color: #aaa;
}
.chat-message-box {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: #fff;
  min-width: 0;
  height: 100%;
  overflow: auto;
}
.no-chat-selected {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #aaa;
  font-size: 18px;
}
</style>
